import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=080f5cb6&scoped=true"
import script from "./Accounts.vue?vue&type=script&lang=js"
export * from "./Accounts.vue?vue&type=script&lang=js"
import style0 from "./Accounts.vue?vue&type=style&index=0&id=080f5cb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080f5cb6",
  null
  
)

export default component.exports